import { RangerSourceMapService } from '../model/ranger-source-map.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { RangerSourceMap } from 'assets-model';
import { Observable } from 'rxjs';


export class RangerSourceMapDataSource extends CrudDataSource<RangerSourceMap> {

  constructor(private service: RangerSourceMapService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<RangerSourceMap>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


